// export default [
//     {
//         id: 1,
//         question: 'کیفیت بالای محصولات',
//         score: ''
//     },
//     {
//         id: 2,
//         question: 'بسته بندی به روز و مناسب محصولات',
//         score: ''
//     },
//     {
//         id: 3,
//         question: 'سبد کالایی متنوع',
//         score: ''
//     },
//     {
//         id: 4,
//         question: 'حاشیه سود مناسب',
//         score: ''
//     },
//     {
//         id: 5,
//         question: 'تبلیغات موثر',
//         score: ''
//     },
//     {
//         id: 6,
//         question: 'قیمت مناسب محصولات',
//         score: ''
//     },
//     {
//         id: 7,
//         question: 'سرکشی و ویزیت های مرتب و متداوم',
//         score: ''
//     },
//     {
//         id: 8,
//         question: 'پاسخگویی مناسب و تحویل سریع',
//         score: ''
//     },
//     {
//         id: 9,
//         question: 'مدت زمان تسویه مناسب',
//         score: ''
//     },
//     {
//         id: 10,
//         question: 'جوایز و آفرها و مشوق های خرید خوب و مناسب',
//         score: ''
//     },
// ]
export default [
  {
    id: 1,
    question: "تنوع محصول",
    score: "",
  },
  {
    id: 2,
    question: "کیفیت محصول",
    score: "",
  },
  {
    id: 3,
    question: "طراحی محصول",
    score: "",
  },
  {
    id: 4,
    question: "بسته بندی محصول",
    score: "",
  },
  {
    id: 5,
    question: "تقاضا برای محصول",
    score: "",
  },
  // {
  //   id: 6,
  //   question: "ویژگی های محصول",
  //   score: "",
  // },
  {
    id:6,
    question: "قیمت مصرف کننده",
    score: "",
  },
  {
    id: 7,
    question: "حاشیه سودفروشنده",
    score: "",
  },
  {
    id: 8,
    question: "تخفیفات نقدی فروش",
    score: "",
  },
  {
    id: 9,
    question: "دوره پرداخت(تسویه)",
    score: "",
  },
  // {
  //   id: 11,
  //   question: "شرایط اعتبارپرداخت",
  //   score: "",
  // },
  {
    id: 10,
    question: "تورویزیت منظم ومداوم",
    score: "",
  },
  {
    id: 11,
    question: "پروموتر(فروشنده ثابت)",
    score: "",
  },
  // {
  //   id: 14,
  //   question: "تبلیغات موثرمحصول",
  //   score: "",
  // },
  {
    id: 12,
    question: "پروموشن (طرح) فروش",
    score: "",
  },
  {
    id: 13,
    question: "مسابقه وقرعه کشی",
    score: "",
  },
  // {
  //   id: 17,
  //   question: "پک چندتایی محصول",
  //   score: "",
  // },
  {
    id: 14,
    question: "مشوق وهدایای ویژه",
    score: "",
  },
  {
    id: 15,
    question: "چالش فروش محصول",
    score: "",
  },
  {
    id: 16,
    question: "خدمات پس از فروش",
    score: "",
  },
  {
    id: 17,
    question: " پوشش کامل شبکه توزیع",
    score: "",
  },
  // {
  //   id: 22,
  //   question: "تنوع کانال های توزیع",
  //   score: "",
  // },
  {
    id: 18,
    question: "میزان رضایت ازتوزیع",
    score: "",
  },
  // {
  //   id: 24,
  //   question: "ارسال سریع سفارشات",
  //   score: "",
  // },
  {
    id: 19,
    question: "حمل ونقل صحیح کالا",
    score: "",
  },
  {
    id: 20,
    question: "نوع تبلیغ",
    score: "",
  },
  {
    id: 21,
    question: "درصد شلف",
    score: "",
  },

];
